export default __webpack_public_path__ + "static/media/ordersEmpty.136f2c80.svg";